import qs from "qs";

export const STRAPI_BASE_URL =
  process.env.REACT_APP_STRAPI_ENDPOINT || "http://localhost:1337";
export const STRAPI_CDN_URL =
  process.env.REACT_APP_CDN_URL || "http://localhost:1337/uploads";


export async function getFgHero() {
  try {
    const query = qs.stringify({
      populate: "*",
    });

    const res = await fetch(`${STRAPI_BASE_URL}/api/fg-hero?${query}`);
    const data = await res.json();

    return data.data || null;
  } catch (err) {
    console.error("Error cargando hero de inicio:", err);
    return null;
  }
}

export async function getFgInicios() {
  try {
    const query = qs.stringify({
      populate: "*",
      sort: ["createdAt:asc"],
    });

    const res = await fetch(`${STRAPI_BASE_URL}/api/fg-inicios?${query}`);
    const data = await res.json();

    return data.data || [];
  } catch (err) {
    console.error("Error cargando fg-inicios:", err);
    return [];
  }
}

export async function getFgInicioById(id: number | string) {
  try {
    const query = qs.stringify({
      populate: "*",
    });

    const res = await fetch(`${STRAPI_BASE_URL}/api/fg-inicios/${id}?${query}`);
    const data = await res.json();

    return data.data || null;
  } catch (err) {
    console.error("Error cargando fg-inicio por id:", err);
    return null;
  }
}